<template>
    <div class="home">
        <b-img src="images/rwkassel.jpg" fluid style="border-radius: 15px;"/>
        <span v-html="$t('presentation.team')" />
        <b-card-group deck>
            <b-card title="Kai Steinert">
                <p class="card-text">
                    Bereichsleitung Interne Dienste<br/><br/>
                    <a href="mailto: Kai.Steinert@rw.net">Kai.Steinert@rw.net</a><br/>
                    Tel. +49 561 7122-210
                </p>
            </b-card>
            <b-card title="Mario Ullrich">
                <p class="card-text">
                    Stellv. Bereichsleitung Interne Dienste<br/><br/>
                    <a href="mailto: Mario.Ullrich@rw.net">Mario.Ullrich@rw.net</a><br/>
                    Tel. +49 160 8836-142
                </p>
            </b-card>
            <b-card title="Christoph Westrup">
                <p class="card-text">
                    Einkaufskoordinator Materialeinkauf und Dienstleistungen<br/><br/>
                    <a href="mailto: Christoph.Westrup@ebnerstolz.de">Christoph.Westrup@ebnerstolz.de</a><br/>
                    Tel. +49 174 8383-808
                </p>
            </b-card>
        </b-card-group>
        <br/>
        <br/>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'team',
        data() {
            return {};
        },
        computed: {
            ...mapGetters({
                auth: 'auth/auth'
            })
        }
    }
</script>